module.exports = __webpack_public_path__ + "static/img/press3.97c2316.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/press3.png
// module id = QVFn
// module chunks = 0